/**
 * Plyr custom controls markup.
 *
 * Exported as a single HTML string used by video-players.esm.js as the
 * `controls` option when constructing Plyr instances.
 *
 * AI: Mostly written by AI
 * Date: 2026-04-25
 * Model: Claude Opus 4.7
 *
 * [PlyrControls]
 */

export const plyrControls = [
  "<button type='button' class='overlayed-play-button show-when-stopped' aria-label='Play {title}' data-plyr='play'>",
    "<span class='visually-hidden'>Play {title}</span>",
    "<span class='inline-icon'>",
      "<svg viewBox='0 0 22 22'><path fill='#000' fill-rule='nonzero' d='M0 0v22l22-11z'/></svg>",
    "</span>",
  "</button>",
  "<div class='plyr__controls'>",
    "<div class='plyr-top'>",
      "<div class='plyr__progress-wrap'>",
        "<div class='plyr__progress'>",
          "<input data-plyr='seek' type='range' min='0' max='100' step='0.01' value='0' aria-label='Seek'>",
          "<progress class='plyr__progress__buffer' min='0' max='100' value='0'>% buffered</progress>",
          "<span role='tooltip' class='plyr__tooltip'>00:00</span>",
        "</div>",
      "</div>",
    "</div>",
    "<div class='plyr-bottom'>",
      "<button class='plyr-play' type='button' data-plyr='play'>",
        "<svg class='show-when-paused'><use xlink:href='#plyr-play'></use></svg>",
        "<span class='show-when-paused plyr__sr-only'>Play</span>",
        "<svg class='show-when-playing'><use xlink:href='#plyr-pause'></use></svg>",
        "<span class='show-when-playing plyr__sr-only'>Pause</span>",
      "</button>",
      "<button type='button' class='plyr__control' aria-label='Mute' data-plyr='mute'>",
        "<svg class='icon--pressed' role='presentation'><use xlink:href='#plyr-muted'></use></svg>",
        "<svg class='icon--not-pressed' role='presentation'><use xlink:href='#plyr-volume'></use></svg>",
      "</button>",
      "<div class='plyr__time-wrap'>",
        "<span class='plyr__time'>",
          "<span class='plyr__sr-only'>Current time</span>",
          "<span class='plyr__time--current'>00:00</span>",
        "</span>",
        "<span class='plyr__time'>",
          "<span class='plyr__sr-only'>Duration</span>",
          "<span class='plyr__time--duration'>00:00</span>",
        "</span>",
      "</div>",
      "<div class='plyr__volume'>",
        "<input data-plyr='volume' type='range' min='0' max='1' step='0.05' value='1' autocomplete='off' aria-label='Volume'>",
      "</div>",
      "<button type='button' class='plyr__button-fullscreen' data-plyr='fullscreen'>",
        "<svg class='icon--exit-fullscreen'><use xlink:href='#plyr-exit-fullscreen'></use></svg>",
        "<svg><use xlink:href='#plyr-enter-fullscreen'></use></svg>",
        "<span class='plyr__sr-only'>Toggle Fullscreen</span>",
      "</button>",
    "</div>",
  "</div>",
].join('');
